import {
    Edit,
    SimpleForm,
    TextInput,
    NumberInput,
    SaveButton,
    Toolbar,
    Button,
    TopToolbar,
    useRecordContext,
} from 'react-admin';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

const EditToolbar = () => (
    <Toolbar>
        <SaveButton />
    </Toolbar>
);

const StringifyValue = () => {
    const record = useRecordContext();
    const { setValue } = useFormContext();

    useEffect(() => {
        if (record && typeof record.value === 'object') {
            setValue('value', JSON.stringify(record.value, null, 2));
        }
    }, [record, setValue]);

    return null;
};

const EditActions = () => (
    <TopToolbar>
        <Button label="Hallinta" component={Link} to="/hallinta?tab=1">
            <ArrowBackIcon />
        </Button>
    </TopToolbar>
);

const ValkeyEdit = () => (
    <Edit mutationMode="pessimistic" actions={<EditActions />}>
        <SimpleForm toolbar={<EditToolbar />}>
            <StringifyValue />
            <TextInput
                source="key"
                label="resources.valkey.fields.key"
                disabled
                fullWidth
            />
            <TextInput
                source="value"
                label="resources.valkey.fields.value"
                multiline
                rows={10}
                fullWidth
            />
            <NumberInput
                source="ttl"
                label="resources.valkey.fields.ttl"
                helperText="TTL sekunteina. Jätä tyhjäksi jos ei halua vanhenemista."
            />
        </SimpleForm>
    </Edit>
);

export default ValkeyEdit;
